import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SavedWrit } from '@models/teranet';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SaleWritState } from '@state/sale_writ';
import { getSearchItemName } from '@core/util/teranet';
import { NewRequisitionModalComponent } from '../../matter-requisition/new-requisition-modal/new-requisition-modal.component';
import { DEFAULT_REQUISITION_DIMENSIONS } from '../..';

@Component({
	selector: 'app-teranet-writs-requisition',
	templateUrl: './teranet-writs-requisition.component.html',
	standalone: false,
})
export class TeranetWritsRequisitionComponent implements OnInit {
	@ViewSelectSnapshot(SaleWritState.savedItems) writs: SavedWrit[];

	public searchNames = [];

	public selectedWrit: SavedWrit;
	public selectedWritId: string;

	public searchName: string;
	public executionsNumber: number;

	ngOnInit() {
		if (this.writs.length) {
			this.selectedWritId = this.writs?.[0]?.id;
			this.selectedWrit = this.writs?.[0];
			this.searchName = getSearchItemName(this.selectedWrit?.search);
			this.executionsNumber = Object.keys(
				this.selectedWrit?.writ?.names,
			).length;

			this.writs.forEach((writ: SavedWrit) => {
				this.searchNames.push({
					label: getSearchItemName(writ.search),
					value: writ.id,
				});
			});
		}
	}

	constructor(private dialog: MatDialog) {}

	createRequisition() {
		if (this.selectedWrit) {
			const fields = {
				searchTextName: this.searchName,
				executionsNumber: this.executionsNumber,
			};

			this.dialog.open(NewRequisitionModalComponent, {
				...DEFAULT_REQUISITION_DIMENSIONS,
				data: { fields },
			});
		}
	}

	onSelectSearchItem(writId: string) {
		this.selectedWrit = this.writs.find((writ) => writ.id === writId);
		this.searchName = getSearchItemName(this.selectedWrit.search);
		this.executionsNumber = Object.keys(this.selectedWrit.writ.names).length;
	}
}
